import $ from 'jquery';
import 'flexslider';


function init() {
  const $slider = $('.slider');
  if ($slider.length) {
    const slider = $slider.flexslider({
      animation: 'slide',
      directionNav: false,
      controlNav: true,
      slideshowSpeed: 10000,
      animationSpeed: 600,
    });
    $('.flex-control-nav a').on('click', () => {
      setTimeout(() => slider.flexslider('play'), 6000);
    });
  }
}

module.exports = { init };



/** WEBPACK FOOTER **
 ** ./src/blocks/slider/slider.js
 **/